// import { createSlice } from '@reduxjs/toolkit';
// import { filterData, filterData as initialFilterData } from '../utils/DummyData';

// const initialState = {
//     filterData: {},
//     selectedFilters: {},
//     loading: {}
// }

// const globalFilterSlice = createSlice({
//     name: 'globalFilter',
//     initialState,
//     reducers: {
//         setInitialData: (state, action) => {
//             state.filterData = action.payload;
//         },
//         setSelectedFilters: (state, action) => {
//             state.selectedFilters = action.payload;
//         },
//         appendMoreData: (state, action) => {
//             const { key, newData, newPagination } = action.payload;
//             if (state.filterData[key]) {
//                 state.filterData[key].data = [...state.filterData[key].data, ...newData];
//                 state.filterData[key].pagination = newPagination;
//             }
//         },
//         removeSelected: (state, action) => {
//             const { category, value } = action.payload;
//             if (state.selectedFilters[category]) {
//                 state.selectedFilters[category] = state.selectedFilters[category].filter(
//                     (item) => item !== value
//                 );
//                 // Remove the key if no items are left
//                 if (state.selectedFilters[category].length === 0) {
//                     delete state.selectedFilters[category];
//                 }
//             }
//         },
//         resetFilter: (state) => {
//             state.selectedFilters = {};
//         },
//         setLoading: (state, action) => {
//             const { key, value } = action.payload;
//             state.loading[key] = value;
//         }
//     }
// })

// export const { setInitialData, setSelectedFilters, appendMoreData, resetFilter, setLoading, removeSelected } = globalFilterSlice.actions;
// export default globalFilterSlice.reducer;



import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    filterData: {},
    selectedFilters: {},
    crossSelectedFilters: {},
    loading: {}
};

const globalFilterSlice = createSlice({
    name: 'globalFilter',
    initialState,
    reducers: {
        setInitialData: (state, action) => {
            state.filterData = action.payload;
        },
        // setSelectedFilters: (state, action) => {
        //     state.selectedFilters = action.payload;
        // },
        setSelectedFilters: (state, action) => {
  const { filters, filterType } = action.payload;
  if (filterType === 'cross') {
    state.crossSelectedFilters = filters;
  } else {
    state.selectedFilters = filters;
  }
},
        appendMoreData: (state, action) => {
            const { key, newData, newPagination } = action.payload;
            if (state.filterData[key]) {
                state.filterData[key].data = [...state.filterData[key].data, ...newData];
                state.filterData[key].pagination = newPagination;
            }
        },
        // removeSelected: (state, action) => {
        //     const { category, value } = action.payload;
        //     if (state.selectedFilters[category]) {
        //         state.selectedFilters[category] = state.selectedFilters[category].filter(
        //             (item) => item !== value
        //         );
        //         if (state.selectedFilters[category].length === 0) {
        //             delete state.selectedFilters[category];
        //         }
        //     }
        // },
        // resetFilter: (state) => {
        //     state.selectedFilters = {};
        // },
        
        removeSelected: (state, action) => {
    const { category, value, filterType } = action.payload;
    const key = filterType === 'cross' ? 'crossSelectedFilters' : 'selectedFilters';
    if (state[key][category]) {
        state[key][category] = state[key][category].filter(
            (item) => item !== value
        );
        if (state[key][category].length === 0) {
            delete state[key][category];
        }
    }
},
resetFilter: (state, action) => {
    const filterType = action?.payload?.filterType;
    if (filterType === 'cross') {
        state.crossSelectedFilters = {};
    } else {
        state.selectedFilters = {};
    }
},
        setLoading: (state, action) => {
            const { key, value } = action.payload;
            state.loading[key] = value;
        }
    }
});

export const {
    setInitialData,
    setSelectedFilters,
    appendMoreData,
    resetFilter,
    setLoading,
    removeSelected
} = globalFilterSlice.actions;

export default globalFilterSlice.reducer;